import { useState, useEffect } from 'react';
import { supabase } from '../utils/supabase';
import { CareerCardSchema } from '../types/careerCard';
import { CACHE_KEYS, CACHE_DURATIONS } from '../constants/cacheKeys';
import { useDataCache } from '../context/DataCacheContext';

export const useCareerCard = () => {
  const [schemas, setSchemas] = useState<CareerCardSchema[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const { invalidateCache } = useDataCache();

  useEffect(() => {
    const fetchSchemas = async () => {
      try {
        const { data, error } = await supabase
          .from('career_card_schemas')
          .select('*')
          .eq('is_active', true)
          .order('card_type');

        if (error) throw error;

        setSchemas(data || []);
        setLoading(false);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Failed to fetch schemas'));
        setLoading(false);
      }
    };

    fetchSchemas();
  }, []);

  return {
    schemas,
    loading,
    error,
    refreshSchemas: () => {
      invalidateCache(CACHE_KEYS.CAREER_CARD_SCHEMAS);
      setLoading(true);
    }
  };
}; 